import { Component } from '@angular/core';
import { DataLoaderService } from '../service-call-index';

@Component({
    selector: 'success-message',
    templateUrl: './success-message.template.html',
    styleUrls: ['./success-message.component.css']
})

export class SuccessMessageComponent {
    public options: any;
    constructor(private dataLoaderService: DataLoaderService) {
    }
    ngOnInit() {
        if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' ) {
            this.options = "Color, Additional Color & Upholstery";
        }
        else {
            this.options = "Color & Upholstery";
        }
    }
    

}





// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/success-message/success-message.component.ts